(function(window, $) {
  'use strict';

  if (!$) {
    return;
  }

  $(window).on('load', function() {
    $('.swatch[data-option-index]').each(function() {
      var optionIndex = parseInt($(this).attr('data-option-index'), 10);

      if (!isNaN(optionIndex)) {
        $('.selector-wrapper').eq(optionIndex).hide();
      }
    });
  });
}(window, window.jQuery));
